/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import L from "../Lang";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Globals from "../../shared/Globals";
import { SidebarGlobal } from "../_SidebarGlobal";
import Icon from "../Icon";
import { Pop } from "../PopModal";
import AppActions from "../AppActions";

// PARAMS: model

class DataManagerList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        await this.loadModel();
        await this.load();
        SidebarGlobal.setSubNav(<>
            <Link to={'/data/' + this.props.params.model + '/new'} className="btn btn-primary">
                <Icon icon="faCirclePlus" /> <L>New</L>
            </Link>
        </>);
    }

    componentDidUpdate(prevProps) {
    }

    componentWillUnmount() {
    }

    loadModel = async () => {
        try {
            const j = await qreq.getAsync('/api/data/model/info/' + this.props.params.model);
            if (j.item) {
                this.setState({ model: j.item });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    load = async () => {
        try {
            const j = await qreq.getAsync('/api/data/model/data/' + this.props.params.model);
            if (j.list) {
                this.setState({ list: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    delete = (i) => {
        Pop.showConfirm(<L>Are you sure you want to delete this item?</L>, <L>Delete</L>, async () => {
            try {
                const j = await qreq.postAsync('/api/data/model/data/delete/' + this.props.params.model, i);
                if (j.errorCode === 0) {
                    this.success('Deleted!');
                    this.load();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    val = (i, c) => {
        const v = i[c.name];
        if (c.dataType === 'Boolean')
            return v ? 'true' : 'false';
        else if (c.dataType === 'DateTime')
            return Globals.toMDYHMLocalDateString(v);
        return v;
    }

    sort = (c) => {
        let isDescending = !this.state.desc;
        const key = c.name;
        const list = [...this.state.list];
        list.sort((a, b) => {
            // 1. Extract values if sorting an array of objects
            let valueA = key !== null ? a[key] : a;
            let valueB = key !== null ? b[key] : b;

            // 2. Handle Date objects or date strings
            if (valueA instanceof Date || (!isNaN(Date.parse(valueA)) && typeof valueA === 'string' && isNaN(valueA))) {
                valueA = new Date(valueA).getTime();
                valueB = new Date(valueB).getTime();
            }

            // 3. Apply comparison logic based on types
            let comparison = 0;
            if (typeof valueA === 'number' && typeof valueB === 'number') {
                comparison = valueA - valueB;
            } else if (typeof valueA === 'string' && typeof valueB === 'string') {
                comparison = valueA.localeCompare(valueB);
            } else {
                // Fallback for mixed or other comparable types
                comparison = valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
            }

            // 4. Reverse the order if descending is requested
            return isDescending ? comparison * -1 : comparison;
        });
        this.setState({ list: list, desc: isDescending, sort: c });
    }

    render() {
        const colFilter = (a) => a.name !== 'masterID' && !a.isFile && !a.isImage;
        return <div className="container-fluid">
            <h1>{this.state.model?.name}</h1>
            <AppActions />
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th style={{ width: '50px' }}></th>
                        <th style={{ width: '50px' }}></th>
                        {this.state.model?.cols?.filter(colFilter).map((c, cdx) => <th key={'c-' + cdx} className="sortable" onClick={() => this.sort(c)}>
                            {c.sortName} {this.state.sort === c && (this.state.desc ? <Icon icon="faCaretDown" /> : <Icon icon="faCaretUp" />)}
                        </th>)}
                    </tr>
                </thead>
                <tbody>
                    {this.state.list?.map((i, idx) => <tr key={idx}>
                        <td className="text-center">
                            <Link to={String(i.id)} title="Edit">
                                <Icon icon="faPencil" role="button" className="text-primary" />
                            </Link>
                        </td>
                        <td className="text-center">
                            <Icon icon="faTrash" role="button" className="text-danger" onClick={() => this.delete(i)} title="Delete" />
                        </td>
                        {this.state.model?.cols?.filter(colFilter).map((c, cdx) => <td key={idx + '-' + cdx}>
                            {this.val(i, c)}
                        </td>)}
                    </tr>)}
                </tbody>
            </table>
        </div>;
    }
}

export default withParamsAndNavigate(DataManagerList);